<template>
    <div class="rfqdetail">
<!--        <el-card>-->
<!--            <el-page-header v-if="from == 'rfq'" @back="goBack" :content="'询报价单详情('+ rfqId + ')'"></el-page-header>-->
<!--            <el-breadcrumb v-if="from == 'menu'" separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>询报价单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>报价录入</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>

                 <el-table stripe
                    size="mini"
                    :data="tableData"
                    ref="detailTable"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column type="selection" width="55"/>
                    <el-table-column
                        prop="itemSku"
                        label="编码"
                        width="100"
                        fixed="left"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="itemName"
                        label="名称"
                        width="300"
                        >
                    </el-table-column>
                     <el-table-column
                        prop="itemNum"
                        label="数量"
                        width="100"
                        align="center"
                     >
                     </el-table-column>
                    <el-table-column
                        prop="itemUnit"
                        label="单位"
                        width="100"
                        align="center"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="itemPrice"
                        label="网站单价(元)"
                        width="120"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="itemTotalPrice"
                        label="网站总价(元)"
                        width="120"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="supplier"
                        label="中标供应商"
                        width="300"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="supplierPrice"
                        label="供应商单价(元)"
                        width="120"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="supplierTotalPrice"
                        label="供应商总价(元)"
                        width="120"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="profitRate"
                        label="利润率(%)"
                        width="160"
                        align="center">
                        <template slot-scope="scope">
                            <el-input-number v-model="scope.row.profitRate" :disabled="scope.row.process != 3" :precision="2" :step="0.01" :min="0" :controls="false" size="mini" @focus="handleSaveOld(scope.row)" @blur="handleEditOne(scope.row)"></el-input-number>
                        </template>
                    </el-table-column>
                    <el-table-column
                             prop="totalNum"
                             label="已报价供应商/已邀约供应商"
                             width="120"
                             align="center">
                         <template slot-scope="scope">
                             <span>{{
                                 scope.row.totalNum?((scope.row.quoteNum?scope.row.quoteNum:"0")+"/"+scope.row.totalNum):"-"

                         }}</span>

                         </template>
                    </el-table-column>
                    <el-table-column
                        prop="csPrice"
                        label="业务员报价单价(元)"
                        width="150"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="csTotalPrice"
                        label="业务员报价总价(元)"
                        width="150"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="price"
                        label="最终报价单价(元)"
                        width="150"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        prop="totalPrice"
                        label="最终报价总价(元)"
                        width="150"
                        align="center">
                    </el-table-column>
                     <el-table-column
                             prop="deadline"
                             label="报价截止日期" width="150" align="center">
                     </el-table-column>
                     <el-table-column
                             prop="sendDay"
                             label="货期(天)"
                             width="100"
                             align="center"/>
                     <el-table-column
                             prop="expireTime"
                             label="价格有效期"
                             width="120"
                             align="center"
                     />
                    <el-table-column
                        prop="remark"
                        label="备注"
                        width="300">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        prop="status"
                        label="状态"
                        width="150" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.process == 0">待分配业务员</el-tag>
                            <el-tag v-if="scope.row.process == 1">待分配供应商</el-tag>
                            <el-tag v-if="scope.row.process == 2">待供应商报价</el-tag>
                            <el-tag v-if="scope.row.process == 3">等待业务报价</el-tag>
                            <el-tag v-if="scope.row.process == 4">等待审核</el-tag>
                            <el-tag v-if="scope.row.process == 5">驳回</el-tag>
                            <el-tag v-if="scope.row.process == 6">通过</el-tag>
                            <el-tag v-if="scope.row.process == 7">下单</el-tag>
                            <el-tag v-if="scope.row.process == 8">发货</el-tag>
                            <el-tag v-if="scope.row.process == 9">收货</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="250" align="right" fixed="right">
                        <template slot="header">
                          <el-button type="primary" size="mini" @click="openSupplier">派发</el-button>
                          <el-button type="primary" size="mini" @click="quote">报价</el-button>
                          <el-button type="primary" size="mini" @click="orderIt">下单</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="showProduct(scope.row.itemId)">查看商品</el-button>
                            <el-divider direction="vertical" v-if="scope.row.process >= 2" ></el-divider>
                            <el-button type="text" v-if="scope.row.process >= 2"
                                    size="mini"
                                    @click="initSupplier(scope.row.id,scope.row.supplierId,scope.row.process,scope.row.itemSku,scope.row.itemName)">指定供应商</el-button>
<!--                            <el-button-->
<!--                                size="mini"-->
<!--                                @click="handleEdit(scope.$index, scope.row)">无法供货</el-button>-->
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :total="total"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="询报单价信息" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="80px">
                <el-form-item label="商品编码">
                    <el-input v-model="editForm.itemId" :disabled="true" placeholder="请输入商品编码" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="editForm.itemName" :disabled="true"  placeholder="请输入商品名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品规格">
                    <el-input v-model="editForm.itemSpecification" :disabled="true"  placeholder="请输入商品规格" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品单位">
                    <el-input v-model="editForm.itemUnit" :disabled="true"  placeholder="请输入商品单位" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品数量">
                    <el-input v-model="editForm.itemNum" :disabled="true"  placeholder="请输入商品数量" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品原价" v-if="$store.state.userInfo.review">
                    <el-input v-model="editForm.itemPrice" :disabled="true" placeholder="请输入商品价格" clearable></el-input>
                </el-form-item>
                <el-form-item label="商品报价">
                    <el-input v-model="editForm.answerPrice" placeholder="请输入商品报价" clearable></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="editForm.remark" placeholder="请输入备注" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="商品报价信息导入" :visible.sync="importDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="80px">
                <el-form-item label="上传报价文件">
                    <el-upload
                            action="/api/admin/uploadFile"
                            accept=".xlsx"
                            :limit="1"
                            :before-upload="beforeUploadFile"
                            :on-change="fileChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList">
                        <el-button size="small" plain>选择文件</el-button>
                        <div slot="tip">只能上传xlsx(Excel2007)文件，且不超过10M</div>
                    </el-upload>
                    <el-input v-model="editForm.filePath" v-show="false" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onUploadSubmit">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="派发询价单" :visible.sync="editSupplier" :close-on-click-modal="false" width="400px">
            <el-form ref="editForm" :model="editForm" label-width="90px" :rules="rules">
                <el-form-item label="供应商" prop="sendId">
                    <el-select v-model="editForm.sendId" placeholder="" multiple="multiple" clearable>
                        <el-option v-for="item in staffs" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editSupplier = false">取 消</el-button>
                <el-button type="primary"  @click="onSend">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="指定供应商" :visible.sync="changeSupplier" :close-on-click-modal="false"
                   width="650px" >
            <div>{{selectedSku}}: {{selectedName}}</div>
            <el-table
                    :data="supplierData"
                    v-loading="loading" max-height="250"
                    style="width: 100%;">

                <el-table-column
                        prop="name"
                        label="供应商"
                        width="100"
                        fixed="left"
                >
                </el-table-column>
                <el-table-column
                        prop="price"
                        label="供应商单价(元)"
                        width="120"
                        align="center">
                    <template slot-scope="scope">
                         <span>{{scope.row.status == 2?(scope.row.price):"-"}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="sendDay"
                        label="货期(天)"
                        width="100"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.status == 2?(scope.row.sendDay):"-"}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="expireTime"
                        label="价格有效期"
                        width="100"
                        align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.status == 2?(scope.row.expireTime):"-"}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="status"
                        label="状态"
                        width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 0">未报价</el-tag>
                        <el-tag v-if="scope.row.status == 1">未报价</el-tag>
                        <el-tag v-if="scope.row.status == 2">已报价</el-tag>
                        <el-tag v-if="scope.row.status == 3">放弃</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="操作"  align="right" fixed="right">

                    <template slot-scope="scope">
                        <el-button type="text" :disabled="scope.row.id == editForm.newSupplier || editForm.process != 3"
                                size="mini"
                                @click="setSupplier(scope.row.id)">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div slot="footer" class="dialog-footer">
                <el-button @click="changeSupplier = false">取 消</el-button>
<!--                <el-button type="primary" @click="setSupplier">确 定</el-button>-->
            </div>
        </el-dialog>
        <el-dialog title="设置利润率" :visible.sync="quoteDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" label-width="80px" :rules="rules">
                <el-form-item label="利润率">
                    <el-input type="number" v-model="editForm.rate"
                    :precision="2" :step="0.01" :min="0" placeholder="请输入利润率"><template slot="append" clearable>%</template></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="quoteDialogVisible = false">取 消</el-button>
                <el-button type="primary"  @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="下单" :visible.sync="orderDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="80px" ref="editForm">
                <el-form-item label="合同号">
                    <el-input v-model="editForm.cn" placeholder="请输入合同号" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="orderDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onOrder">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="商品信息" :visible.sync="productDialogVisible" width="700px" :close-on-click-modal="false">
            <el-descriptions class="margin-top" :column="2" :size="size" border>
                <el-descriptions-item span="2" labelStyle="width:100px;">
                <template slot="label">
                    商品名称
                </template>
                {{product.name}}
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width:100px;">
                <template slot="label">
                    物料号
                </template>
                {{product.customMaterialNumber}}
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width:100px;">
                <template slot="label">
                    品牌
                </template>
                {{product.brandNameCh}}
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width:100px;">
                <template slot="label">
                    型号
                </template>
                {{product.model}}
                </el-descriptions-item>
                <el-descriptions-item labelStyle="width:100px;">
                <template slot="label">
                    规格
                </template>
                {{product.specs}}
                </el-descriptions-item>
                <el-descriptions-item span="2" labelStyle="width:100px;">
                <template slot="label">
                    备注
                </template>
                {{product.description}}
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchForm: {
                itemId: "",
                itemName: "",
                itemPrice: "",
                buyerCode: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            editDialogVisible: false,
            importDialogVisible: false,
            editForm: {
                rfqId: "",
                rfqName: "",
                id: "",
                userId: null,
                itemId: "",
                itemName: "",
                itemPrice: "",
                answerPrice: "",
                itemSpecification: "",
                itemNum: "",
                itemUnit: "",
                remark: "",
                filePath: "",
                expireTime: "",
                sendDay: "",
                rate: 0,
                cn: '',
                supplier: '',
                sendId:[],
                newSupplier:'',
                process:''
            },
            productDialogVisible: false,
            product: {},
            staffs: [],//
            allSupplier: [],//可选的派发的供应商
            supplier: [],//可指定的供应商
            send:true,//选择供应商
            editSupplier: false,
            changeSupplier: false,
            quoteDialogVisible: false,
            orderDialogVisible: false,
            oldProfitRate: 0,
            rules: {
                sendId: [
                    { required: true, message: '请选择供应商', trigger: 'blur' }
                ],
                expireTime: [
                    { required: true, message: '选择报价截止日', trigger: 'blur' }
                ],
                rate: [
                    { required: true, message: '请输入利润率', trigger: 'blur' }
                ],
                newSupplier: [
                    { required: true, message: '请选择供应商', trigger: 'blur' }
                ],
            },
            supplierData:[],
        }
    },
    props: ["from", "rfqId"],
    methods: {
        onSearch() {
            let url = "/admin/rfq/rfqdetail/search";
            if(this.$store.state.userInfo.type == 2){
                url = "/admin/rfq/rfqdetail/supplier/search";
            }
            if(this.rfqId) {
                this.loading = true;
                let _this = this
                this.$axios.post(url,{
                    cond: {rfqId: this.rfqId},
                    page: this.currentPage - 1,size:this.pageSize
                }).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.loading = false;
                        _this.tableData = resp.data.content;
                        _this.total = resp.data.totalElements;
                    }
                }).catch(function() {
                });
            }
        },
        handleCreate() {
            this.editForm.rfqId= this.rfqId;
            this.editForm.itemId = "";
            this.editForm.itemPrice = "";
            this.editForm.itemName = "";
            this.editDialogVisible = true;
        },
        handleCreateImport() {
            this.editForm.agreementId= this.agreementId;
            this.importDialogVisible = true;
        },
        onSubmit() {
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.$confirm('是否确认提交报价信息？', '确认信息', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确认',
                        cancelButtonText: '取消'
                    }).then(() => {
                        const postData = {
                            ids: this.$refs.detailTable.selection.map(it => it.id),
                            rate: this.editForm.rate,
                        };
                        let _this = this;
                        this.$axios.post("/admin/quote/csQuote", postData)
                            .then(function (response) {
                                let resp = response.data;
                                if (resp.header.status == 0) {
                                    _this.$notify({
                                        title: '成功',
                                        message: '数据保存成功',
                                        type: 'success'
                                    });
                                    _this.quoteDialogVisible = false;
                                    _this.onSearch();
                                } else {
                                    _this.$notify.error({
                                        title: '错误',
                                        message: resp.header.msg
                                    });
                                }
                            });

                    });
                }
            });
        },
        onUploadSubmit() {
            let _this = this;
            this.$axios.post("/admin/rfq/rfqdetail/onUploadSubmit", this.editForm)
            .then(function(response){
                let resp = response.data;
                if(resp.header.status == 0) {
                    _this.$notify({
                        title: '成功',
                        message: '数据保存成功',
                        type: 'success'
                    });
                    _this.importDialogVisible = false;
                    _this.onSearch();
                } else {
                    _this.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        handleEdit(index, row) {
            this.editForm.id = row.id;
            this.editForm.rfqId = row.rfqId;
            this.editForm.rfqName = row.rfqName;
            this.editForm.itemId = row.itemId;
            this.editForm.itemName = row.itemName;
            this.editForm.itemNum = row.itemNum;
            this.editForm.itemUnit = row.itemUnit;
            this.editForm.itemPrice = row.itemPrice;
            this.editForm.itemSpecification = row.itemSpecification;
            this.editForm.price = row.price;
            this.editForm.totalPrice = row.totalPrice;
            this.editForm.remark = row.remark;

            if(this.$store.state.userInfo.type == 2) {
                this.editSupplierVisible = true;
            }else{
                this.editDialogVisible = true;
            }
        },

        handleSaveOld(row) {
            this.oldProfitRate = row.profitRate;
        },
        handleEditOne(row) {
            if(row.profitRate == this.oldProfitRate) {
                return;
            }

            const postData = {
                ids: [row.id],
                rate: row.profitRate,
            };
            let that = this;
            this.$axios.post("/admin/quote/csQuote", postData)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },

        handleDelete(index, row) {
            let _this = this;
            this.$confirm('是否删除协议价格【' + row.itemId + '】？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '删除',
                cancelButtonText: '取消'
            }).then(() => {
                _this.$axios.get("/admin/rfq/rfqdetail/delete/" + row.id)
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status === 0) {
                        _this.$notify({
                            title: '成功',
                            message: '数据删除成功',
                            type: 'success'
                        });
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
            })
        },
        // 文件状态改变时的钩子
        fileChange(file) {
            this.editForm.file = file.raw
        },
        // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
        beforeUploadFile(file) {

            let extension = file.name.substring(file.name.lastIndexOf('.')+1)
            let size = file.size / 1024 / 1024
            if(extension !== 'xlsx') {
                this.$notify.warning({
                    title: '警告',
                    message: `只能上传Excel2017（即后缀是.xlsx）的文件`
                });
            }
            if(size > 10) {
                this.$notify.warning({
                    title: '警告',
                    message: `文件大小不得超过10M`
                });
            }
        },
        // 文件上传成功时的钩子
        handleSuccess(res, file) {
            this.$notify.success({
                title: '成功',
                message: `文件上传成功`
            });
            if (file.response.data.success) {
                this.editForm.filePath = file.response.data.message; //将返回的文件储存路径赋值picture字段
            }
        },
        // 文件上传失败时的钩子
        handleError() {
            this.$notify.error({
                title: '错误',
                message: `文件上传失败`
            });
        },
        goBack() {
            this.$router.go(-1);

        },
        initStaffs() {//加载供应商
            let _this = this;
            this.$axios.post("/admin/rights/staff/list",{type:2})
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.allSupplier.length = 0;

                        for(let i=0; i<resp.data.length; i++) {
                            let data = resp.data[i];
                            _this.allSupplier.push({
                                label: data.name,
                                value: data.id,
                            });
                            _this.staffs = _this.allSupplier;
                        }

                    }
                })

        },
        showProduct(id) {
            let that = this;
            this.productDialogVisible = true;
            this.$axios.get("/admin/product/" + id)
            .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.product = resp.data;
                    }
                }).catch(function() {
                });
        },
        onSend() {
            if( this.editForm.sendId.length == 0){
                this.$notify.warning({
                    title: '提示',
                    message: "请先选择供应商"
                });
                return;
            }
            let that = this;
            let rfqDetailList = [];
            let arr = this.$refs.detailTable.selection;//选中的询价单列表
            for(let i=0; i<arr.length; i++){
                rfqDetailList.push(arr[i].id);
            }

            this.$axios.post("/admin/rfq/askSend",{
                rfqId: this.rfqId,
                details: rfqDetailList,//询价单明细id列表
                staffId: this.editForm.sendId,
            }).then(function(response) {
                let resp = response.data;
                if(resp.header.status == 0) {
                    that.$notify({
                        title: '成功',
                        message: '派发询价单成功',
                        type: 'success'
                    });
                    that.editSupplier = false;
                    that.onSearch();
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            })


        },
        setSupplier(id) {
            this.$confirm('是否确认指定供应商？', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then(() => {
                let that = this;

                this.$axios.post("/admin/quote/setSupplier", {

                    detailId: this.editForm.id,//询价单明细id列表
                    supplierId: id,
                }).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '指定供应商成功',
                            type: 'success'
                        });
                        that.changeSupplier = false;
                        that.onSearch();
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                })
            });


        },
        openSupplier() {
            this.send = true;
            this.editForm.sendId = [];
            if(this.$refs.detailTable.selection.length == 0){
                this.$notify.warning({
                    title: '提示',
                    message: "请先勾选询价单"
                });
                return;
            }
            if(this.$refs.detailTable.selection.filter(it => ((it.isAgree==0 && it.process == 3)||
                (it.supplierId != null && it.process == 6))).length > 0) {
                this.$notify.warning({
                    title: '提示',
                    message: "请勾选待分配供应商的预询价单"
                });
                return;
            }
            this.staffs = this.allSupplier;
            this.editSupplier = true;
        },
        quote() {
            if(this.$refs.detailTable.selection.length == 0){
                this.$notify.warning({
                    title: '提示',
                    message: "请先勾选询价单"
                });
                return;
            }
            if(this.$refs.detailTable.selection.filter(it => it.process != 3).length > 0) {
                this.$notify.warning({
                    title: '提示',
                    message: "请先勾选待业务员报价的预询价单"
                });
                return;
            }
            this.quoteDialogVisible = true;
        },
        orderIt() {
            if(this.$refs.detailTable.selection.length == 0){
                this.$notify.warning({
                    title: '提示',
                    message: "请先勾选询价单"
                });
                return;
            }

            if(this.$refs.detailTable.selection.filter(it => it.process == 6).length != this.$refs.detailTable.selection.length) {
                this.$notify.warning({
                    title: '提示',
                    message: "请勾选已经通过报价的订单"
                });
                return;
            }
            this.editForm.cn = "";
            this.orderDialogVisible = true;
        },
        onOrder() {
            if(this.editForm.cn == ""){
                this.$notify.warning({
                    title: '提示',
                    message: "请输入合同号"
                });
                return;

            }
            const postData ={
                rfqId: this.rfqId,
                details: this.$refs.detailTable.selection.map(it => it.id),
                cn: this.editForm.cn,
            };
            let _this = this;
            this.$axios.post("/admin/order/save", postData)
                .then(function(response){
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.$notify({
                            title: '成功',
                            message: '下单成功',
                            type: 'success'
                        });
                        _this.orderDialogVisible = false;
                        _this.onSearch();
                    } else {
                        _this.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        // onInputBlur(){//利润率
        //     this.onSubmit();

        //     // const postData ={
        //     //     ids: this.$refs.detailTable.selection.map(it => it.id),
        //     //     rate: this.editForm.rate,
        //     // };
        // }

        initSupplier(detailId,supplier,process,sku,name) {//加载供应商(已报价)

            this.editForm.newSupplier = supplier;
            this.editForm.id = detailId;
            this.editForm.supplier = supplier;
            this.editForm.process = process;
            this.selectedSku = sku;
            this.selectedName = name;
            this.send = false;
            let _this = this;
            _this.supplierData = [];
            this.$axios.post("/admin/rfq/loadSupplier",{id:detailId})
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        _this.supplierData = resp.data;

                        _this.changeSupplier = true;

                    }
                })

        },


    },
    created() {
        let paramsStore;
        const params = sessionStorage.getItem("params");
        if(params) {
            paramsStore = JSON.parse(params);
        }
        const { rfqId } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
        this.rfqId = rfqId;
        this.onSearch();
        this.initStaffs();

      //  console.log(this.$store.state.userInfo.type);
    },
}
</script>
<style>

</style>